
import Vue from 'vue'

interface Link {
    id: string,
    url: string,
    title: string,
    type: string,
	text: string,
	tags: string[],
	image_url: string
}

interface Props {
    links: Link[],
	isListView: boolean,
	listType: string,
	showTags: boolean,
	showImage: boolean,
	boxFullHeight: string,
	sort: string,
	showIngress: boolean
}


export default Vue.extend<{}, {}, Props, {}>({
	name: 'Related pages',
	computed:{
        links(){
			console.log('links ' + this.$store.getters.links);

			return this.$store.getters.links;
		},
		isListView(){
			console.log('isListView: ' + this.$store.getters.isListView); 
			return this.$store.getters.isListView;
		},
		listType() {
			return this.$store.getters.listType;
		},
		showTags(){
			console.log('showTags ' + this.$store.getters.showTags); 
			return this.$store.getters.showTags;
		},
		showImage(){
			console.log('showImage ' + this.$store.getters.showImage); 
			return this.$store.getters.showImage;
		},
		boxFullHeight(){
			console.log('boxFullHeight ' + this.$store.getters.boxFullHeight); 
			return this.$store.getters.boxFullHeight;
		},
		sort() {
			return this.$store.getters.sort;
		},
		showIngress() {
			return this.$store.getters.showIngress;
		}
	}
})
